import React from 'react'

import { ZariContext } from '_zari/context'
import { Form, Button, Col, Row } from '_zari/core'

import { LadosIsla } from 'constants/index'

import * as IslaCombustibleService from 'services/islaCombustible.service'
import * as ProductoService from 'services/producto.service'

const CeldaEliminar = ({ combustible, idItem, refrescarCombustiblexIsla }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickEliminar = React.useCallback(() => {
    IslaCombustibleService.eliminarxId(idItem)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha eliminado.')
        refrescarCombustiblexIsla()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, idItem, refrescarCombustiblexIsla])

  return (
    <td className='p-1'>
      <Row>
        <Col md={10}>{combustible || '--'}</Col>
        <Col md={2}>
          <Button tiny outline onClick={clickEliminar} color='danger'>
            x
          </Button>
        </Col>
      </Row>
    </td>
  )
}

const CeldaAgregar = ({ infoIsla, lado, refrescarCombustiblexIsla, arrayCombustibles }) => {
  const __zariContext = React.useContext(ZariContext)

  const [combustible, setCombustible] = React.useState('')

  const clickAgregar = React.useCallback(() => {
    IslaCombustibleService.nuevo({
      _idIsla: infoIsla._id,
      lado: lado,
      combustible: combustible
    })
      .then(() => {
        __zariContext.snack('success', 'El registro se ha agregado.')
        refrescarCombustiblexIsla()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, infoIsla, lado, combustible, refrescarCombustiblexIsla])

  return (
    <td className='p-1'>
      <Row>
        <Col md={10}>
          <Form.Select
            id={`select-combustible-${infoIsla._id}`}
            name={`select-combustible-${infoIsla._id}`}
            value={combustible}
            onChange={e => setCombustible(e.target.value)}
          >
            <option value=''>Seleccionar</option>
            {arrayCombustibles &&
              arrayCombustibles.map(x => (
                <option key={x.id} value={x.codigo}>
                  {x.nombre}
                </option>
              ))}
          </Form.Select>
        </Col>
        <Col md={2}>
          <Button tiny outline onClick={clickAgregar}>
            +
          </Button>
        </Col>
      </Row>
    </td>
  )
}

const RowTemplate = ({ infoIsla, combustiblesxIsla, refrescarCombustiblexIsla }) => {
  const [arrayCombustibles, setArrayCombustibles] = React.useState([])

  React.useEffect(() => {
    ProductoService.obtenerAsCombustibles().then(({ data }) => {
      setArrayCombustibles(data)
    })
  }, [])

  const filasLado1 = React.useMemo(() => {
    const combustiblesLado1 = combustiblesxIsla.filter(y => y.lado === LadosIsla.Lado1)
    combustiblesLado1.push({ filaAgregar: true, lado: LadosIsla.Lado1 })
    return combustiblesLado1
  }, [combustiblesxIsla])

  const filasLado2 = React.useMemo(() => {
    const combustiblesLado2 = combustiblesxIsla.filter(y => y.lado === LadosIsla.Lado2)
    combustiblesLado2.push({ filaAgregar: true, lado: LadosIsla.Lado2 })
    return combustiblesLado2
  }, [combustiblesxIsla])

  const totalFilas = React.useMemo(() => {
    return [...filasLado1, ...filasLado2]
  }, [filasLado1, filasLado2])

  const toRender = React.useMemo(() => {
    let salida = []

    for (let i = 0; i < totalFilas.length; i++) {
      const infoFila = totalFilas[i]

      if (i === 0) {
        salida.push(
          <tr key={i}>
            <td rowSpan={totalFilas.length} align='center'>
              {infoIsla.nombre}
            </td>
            <td rowSpan={filasLado1.length} align='center'>
              {LadosIsla.Lado1}
            </td>
            {infoFila.filaAgregar ? (
              <CeldaAgregar
                arrayCombustibles={arrayCombustibles}
                infoIsla={infoIsla}
                lado={infoFila.lado}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            ) : (
              <CeldaEliminar
                combustible={infoFila.combustible}
                idItem={infoFila._id}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            )}
          </tr>
        )
      } else if (i === filasLado1.length) {
        salida.push(
          <tr key={i}>
            <td rowSpan={filasLado2.length} align='center'>
              {LadosIsla.Lado2}
            </td>
            {infoFila.filaAgregar ? (
              <CeldaAgregar
                arrayCombustibles={arrayCombustibles}
                infoIsla={infoIsla}
                lado={infoFila.lado}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            ) : (
              <CeldaEliminar
                combustible={infoFila.combustible}
                idItem={infoFila._id}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            )}
          </tr>
        )
      } else {
        salida.push(
          <tr key={i}>
            {infoFila.filaAgregar ? (
              <CeldaAgregar
                arrayCombustibles={arrayCombustibles}
                infoIsla={infoIsla}
                lado={infoFila.lado}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            ) : (
              <CeldaEliminar
                combustible={infoFila.combustible}
                idItem={infoFila._id}
                refrescarCombustiblexIsla={refrescarCombustiblexIsla}
              />
            )}
          </tr>
        )
      }
    }

    return salida
  }, [infoIsla, totalFilas, filasLado1.length, filasLado2.length, refrescarCombustiblexIsla, arrayCombustibles])

  return toRender
}

export default React.memo(RowTemplate)
